import React, { useState } from "react";
import "./Permissions.css";
import CustomToolTip from "../CustomToolTip/CustomToolTip";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import Upgrade from "./Upgrade/Upgrade";
function View({ title, description, img }) {
  const [upgradeToggle, setUpgradeToggle] = useState(false);
  return <div>Permission denied </div>;
  return (
    <div className={"col-md-12 view-permission global-fade-in "}>
      <div className={"calc"}></div>
      <div className={"view-permission-message "}>
        <div className={"message-box"}>
          <div>
            <img
              src="assets/images/star.png"
              className={"champion-img"}
              alt=""
            />
          </div>
          <div className={"message-header"}>
            {/* <h2>{title}</h2>
            <p>{description}</p>*/}
            <h2>Hit your next target</h2>
            <p>
              All of Kaspr's features help make your prospecting easier. Upgrade
              for more automation and insights.
            </p>
          </div>
          <div className={"btns"}>
            <button
              className={"btn btn1"}
              onClick={() => setUpgradeToggle(true)}
            >
              {" "}
              <img
                src="/assets/images/crown.png"
                style={{ width: 20, marginTop: -5, marginRight: 5 }}
                alt=""
              />
              <span> Upgrade your plan</span>
            </button>
            {/*  <NavLink to={"/billing"}>
              <button className={"btn btn1"}>
                {" "}
                <img
                  src="/assets/images/crown.png"
                  style={{ width: 20, marginTop: -5, marginRight: 5 }}
                  alt=""
                />
                <span> Upgrade your plan</span>
              </button>
            </NavLink>*/}
            {upgradeToggle && (
              <Upgrade onClose={setUpgradeToggle} toggle={upgradeToggle} />
            )}
          </div>
        </div>
      </div>
      <img className={"blur-bg"} src={"/assets/images/" + img} alt="" />
    </div>
  );
}
function CallToAction({
  children,
  text,
  isButton,
  withoutIcon,
  isPlan,
  toolTipStyle,
  toolTipPosition,
  buttonStyle,
  containerStyle,
  tooltipContainerStyle,
}) {
  if (withoutIcon) {
    return (
      <span className={"calltoaction-permission"} style={containerStyle}>
        <CustomToolTip
          style={toolTipStyle}
          position={toolTipPosition}
          tooltipContainerStyle={tooltipContainerStyle}
          element={
            isPlan ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  className={"crown"}
                  src="/assets/images/crown.png"
                  alt=""
                />{" "}
                <div style={{ color: "#fff", fontSize: 15, lineHeight: 1.2 }}>
                  <FormattedMessage id={"permissions.upgradePlan"} />
                </div>
              </div>
            ) : (
              <div style={{ color: "#fff", fontSize: 15, lineHeight: 1.2 }}>
                <FormattedMessage id={"permissions.noAccess"} />
              </div>
            )
          }
        >
          <span style={{ opacity: 0.5, pointerEvents: "none" }}>
            {children}
          </span>
        </CustomToolTip>
      </span>
    );
  }
  if (isButton) {
    return (
      <span className={"calltoaction-permission"}>
        <CustomToolTip
          style={toolTipStyle}
          position={toolTipPosition}
          element={
            isPlan ? (
              <p>
                <FormattedMessage id={"permissions.upgradePlan"} />
              </p>
            ) : (
              <p>
                <FormattedMessage id={"permissions.noAccess"} />
              </p>
            )
          }
        >
          <button className={"btn btn1 "} style={{ width: "max-content" }}>
            {isPlan && (
              <img className={"crown"} src="/assets/images/crown.png" alt="" />
            )}
            <span>{children}</span>
          </button>
        </CustomToolTip>
      </span>
    );
  }

  return (
    <span className={"calltoaction-permission"}>
      <CustomToolTip
        style={toolTipStyle}
        position={toolTipPosition}
        element={
          isPlan ? (
            <p>
              <FormattedMessage id={"permissions.upgradePlan"} />
            </p>
          ) : (
            <p>
              <FormattedMessage id={"permissions.noAccess"} />
            </p>
          )
        }
      >
        <span>
          {children}{" "}
          {isPlan && (
            <img className={"crown"} src="/assets/images/crown.png" alt="" />
          )}
        </span>
      </CustomToolTip>
    </span>
  );
}

export { View, CallToAction };
